import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtojamkhandicab() {



    const cardData = {




keyword: "Belgaum to Jamkhandi Cab",

headingDescription: "Belgaum Taxi Service provides reliable and comfortable Belgaum to Jamkhandi cab services for family travel, business trips, local transportation, medical visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Jamkhandi, we offer safe and convenient travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options based on your travel needs. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service connects passengers between Belgaum and Jamkhandi with affordable and comfortable cab solutions for individuals, families, and business travelers across Karnataka.",

topPlaces: [
  {
    title: "Jamkhandi",
    description: "Jamkhandi is a historic town in Bagalkot district known for its royal heritage, agriculture, temples, and local markets. It is a frequently traveled destination from Belgaum."
  },
  {
    title: "Bagalkot",
    description: "Bagalkot is an important city in Karnataka known for business activities, historical attractions, and connectivity to famous heritage destinations like Badami and Pattadakal."
  },
  {
    title: "Badami",
    description: "Badami is a popular heritage destination famous for rock-cut cave temples, ancient architecture, and Chalukyan history, attracting tourists throughout the year."
  },
  {
    title: "Aihole",
    description: "Aihole is known for its ancient temples and architectural monuments, making it a preferred destination for history enthusiasts and educational tours."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site famous for its beautifully designed temples and historical significance in Karnataka."
  },
  {
    title: "Bijapur",
    description: "Bijapur is a historic city known for Gol Gumbaz, ancient monuments, and cultural heritage. It is a popular destination for sightseeing and family trips."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for ancient ruins, temples, and historical landscapes, making it a popular tourist destination in Karnataka."
  },
  {
    title: "Goa",
    description: "Goa is a famous holiday destination known for beaches, resorts, churches, and sightseeing attractions. Private cabs provide comfortable travel for leisure trips."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial city in Maharashtra. Cab services are preferred for business travel, family visits, and long-distance journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with business districts, airports, and tourist attractions. Comfortable outstation cabs provide convenient connectivity from Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Jamkhandi Cab",
    "description": "Book Belgaum to Jamkhandi Cab for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Get convenient cab services for personal trips, family visits, business travel, and local transportation with flexible booking options."
  },
  {
    "name": "Belgaum to Jamkhandi Taxi",
    "description": "Hire Belgaum to Jamkhandi Taxi for affordable and comfortable transportation between both locations. Choose from Sedan, Ertiga, Innova Crysta, and SUV taxis with experienced drivers for a smooth and convenient journey."
  },
  {
    "name": "Belgaum to Jamkhandi Cab Service",
    "description": "Choose Belgaum to Jamkhandi Cab Service for reliable intercity transportation with doorstep pickup, transparent pricing, and professional chauffeurs. Our cab services are suitable for family travel, business trips, and outstation journeys."
  },
  {
    "name": "Belgaum to Jamkhandi Taxi Service",
    "description": "Book Belgaum to Jamkhandi Taxi Service for comfortable and hassle-free travel. Enjoy clean AC vehicles, trained drivers, affordable fares, and flexible one way or round trip taxi options."
  },
  {
    "name": "Belgaum to Jamkhandi One Way Cab",
    "description": "Reserve Belgaum to Jamkhandi One Way Cab for economical point-to-point travel without return charges. Get fixed pricing, comfortable vehicles, and professional driver assistance for a smooth journey."
  },
  {
    "name": "Belgaum to Jamkhandi One Way Taxi",
    "description": "Choose Belgaum to Jamkhandi One Way Taxi for budget-friendly single destination travel. Enjoy convenient pickup, clean vehicles, and experienced chauffeurs for safe transportation."
  },
  {
    "name": "Belgaum to Jamkhandi Cab Booking",
    "description": "Complete Belgaum to Jamkhandi Cab Booking with easy online reservations and quick confirmation. Select your preferred vehicle based on passengers, luggage requirements, and travel comfort."
  },
  {
    "name": "Belgaum to Jamkhandi Taxi Booking",
    "description": "Book Belgaum to Jamkhandi Taxi Booking services for reliable and comfortable transportation. Enjoy affordable pricing, flexible travel options, and professional drivers for a hassle-free journey."
  },
  {
    "name": "Belgaum to Jamkhandi Car Rental",
    "description": "Choose Belgaum to Jamkhandi Car Rental with driver for flexible travel solutions. Hire comfortable cars for family trips, business visits, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Jamkhandi Outstation Cab",
    "description": "Travel with Belgaum to Jamkhandi Outstation Cab services offering safe and comfortable intercity transportation. Get reliable vehicles, experienced chauffeurs, and flexible one way or round trip options."
  },
  {
    "name": "Belgaum to Jamkhandi Innova Crysta Cab",
    "description": "Book Belgaum to Jamkhandi Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, large luggage space, and comfortable rides for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Jamkhandi Ertiga Cab",
    "description": "Hire Belgaum to Jamkhandi Ertiga Cab for comfortable 6 to 7 seater travel. Perfect for family trips, group journeys, and outstation transportation with affordable fares."
  },
  {
    "name": "Belgaum to Jamkhandi Sedan Cab",
    "description": "Choose Belgaum to Jamkhandi Sedan Cab for economical and comfortable travel. Enjoy clean AC sedans with professional drivers suitable for business and personal journeys."
  },
  {
    "name": "Belgaum to Jamkhandi Round Trip Cab",
    "description": "Book Belgaum to Jamkhandi Round Trip Cab for convenient return journeys with affordable packages. Ideal for family visits, business travel, and planned trips."
  },
  {
    "name": "Belgaum to Jamkhandi Private Taxi",
    "description": "Hire Belgaum to Jamkhandi Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and flexible travel schedules."
  },
  {
    "name": "Cheap Belgaum to Jamkhandi Cab",
    "description": "Find Cheap Belgaum to Jamkhandi Cab services offering affordable fares with quality vehicles and reliable drivers. Travel comfortably with budget-friendly taxi solutions."
  },
  {
    "name": "Best Belgaum to Jamkhandi Cab Service",
    "description": "Choose the Best Belgaum to Jamkhandi Cab Service with premium vehicles, experienced chauffeurs, and competitive pricing. Get dependable transportation solutions for individuals, families, and businesses."
  },
  {
    "name": "Online Belgaum to Jamkhandi Cab Booking",
    "description": "Book Online Belgaum to Jamkhandi Cab Booking services with easy reservations and instant confirmation. Select from multiple cab options for comfortable and convenient travel."
  },
  {
    "name": "Belgaum to Jamkhandi Taxi Fare",
    "description": "Get affordable Belgaum to Jamkhandi Taxi Fare with transparent pricing and flexible packages. Choose suitable vehicle options according to your travel requirements and budget."
  },
  {
    "name": "Belgaum to Jamkhandi Car Hire",
    "description": "Hire Belgaum to Jamkhandi Car Hire services with reliable vehicles and professional drivers. Suitable for family travel, corporate visits, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Jamkhandi Cab Price",
    "description": "Check Belgaum to Jamkhandi Cab Price and select affordable travel options. Get comfortable AC cabs with flexible booking facilities for one way and round trip journeys."
  },
  {
    "name": "Belgaum to Jamkhandi Family Cab",
    "description": "Book Belgaum to Jamkhandi Family Cab for safe and spacious travel. Enjoy comfortable seating, experienced drivers, and convenient transportation for family trips."
  },
  {
    "name": "Belgaum to Jamkhandi Corporate Taxi",
    "description": "Choose Belgaum to Jamkhandi Corporate Taxi services for professional business transportation. Get punctual service, reliable vehicles, and experienced chauffeurs for corporate requirements."
  },
  {
    "name": "Belgaum to Jamkhandi Airport Transfer",
    "description": "Book Belgaum to Jamkhandi Airport Transfer service for timely airport pickup and drop facilities. Travel comfortably with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Jamkhandi Cab Fare",
    "description": "Get details about Belgaum to Jamkhandi Cab Fare with affordable rates and multiple vehicle choices. Book Sedan, Ertiga, Innova Crysta, or SUV cabs according to your needs."
  },
  {
    "name": "Belgaum to Jamkhandi Taxi Near Me",
    "description": "Find Belgaum to Jamkhandi Taxi Near Me for quick and reliable taxi availability. Book comfortable cabs with experienced drivers for safe and convenient travel."
  },
  {
    "name": "Belgaum to Jamkhandi Outstation Taxi",
    "description": "Hire Belgaum to Jamkhandi Outstation Taxi for comfortable long-distance travel with clean vehicles and professional chauffeurs. Enjoy reliable transportation for personal, family, and business journeys."
  },
  {
    "name": "Belgaum to Jamkhandi Travel by Cab",
    "description": "Travel from Belgaum to Jamkhandi by Cab with convenient booking options, comfortable vehicles, and experienced drivers. Enjoy smooth and stress-free transportation throughout your journey."
  }
],
"tableData": [
  ["Belgaum to Jamkhandi Cab", "Belgaum to Jamkhandi Taxi"],
  ["Belgaum to Jamkhandi Cab Service", "Belgaum to Jamkhandi Taxi Service"],
  ["Belgaum to Jamkhandi One Way Cab", "Belgaum to Jamkhandi One Way Taxi"],
  ["Belgaum to Jamkhandi Cab Booking", "Belgaum to Jamkhandi Taxi Booking"],
  ["Belgaum to Jamkhandi Car Rental", "Belgaum to Jamkhandi Outstation Cab"],
  ["Belgaum to Jamkhandi Innova Crysta Cab", "Belgaum to Jamkhandi Ertiga Cab"],
  ["Belgaum to Jamkhandi Sedan Cab", "Belgaum to Jamkhandi Round Trip Cab"],
  ["Belgaum to Jamkhandi Private Taxi", "Cheap Belgaum to Jamkhandi Cab"],
  ["Best Belgaum to Jamkhandi Cab Service", "Online Belgaum to Jamkhandi Cab Booking"],
  ["Belgaum to Jamkhandi Taxi Fare", "Belgaum to Jamkhandi Car Hire"],
  ["Belgaum to Jamkhandi Cab Price", "Belgaum to Jamkhandi Family Cab"],
  ["Belgaum to Jamkhandi Corporate Taxi", "Belgaum to Jamkhandi Airport Transfer"],
  ["Belgaum to Jamkhandi Cab Fare", "Belgaum to Jamkhandi Taxi Near Me"],
  ["Belgaum to Jamkhandi Outstation Taxi", "Belgaum to Jamkhandi Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Jamkhandi Cab Service",
    WhyChoosedescription: "Travel from Belgaum to Jamkhandi with a convenient taxi service that offers comfortable vehicles, experienced drivers, and smooth transportation for personal and business journeys."
  },
  {
    WhyChooseheading: "Reliable Doorstep Travel Facility",
    WhyChoosedescription: "Get pickup from your preferred location in Belgaum and enjoy direct drop service in Jamkhandi without the hassle of arranging multiple transport options."
  },
  {
    WhyChooseheading: "Flexible Vehicle Selection",
    WhyChoosedescription: "Choose a suitable cab from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV options according to your travel comfort and group size."
  },
  {
    WhyChooseheading: "Suitable for Various Travel Needs",
    WhyChoosedescription: "Our Belgaum to Jamkhandi taxis are ideal for family visits, business work, personal trips, medical travel, and regular transportation requirements."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Smooth Journey",
    WhyChoosedescription: "Professional drivers ensure safe travel, timely pickup, and a comfortable ride with proper knowledge of the Belgaum to Jamkhandi route."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Plan your travel easily with one-way drop cabs or choose a return journey package based on your schedule and convenience."
  },
  {
    WhyChooseheading: "Affordable Taxi Travel Options",
    WhyChoosedescription: "Get practical cab solutions with transparent pricing and vehicle choices that match your travel requirements."
  },
  {
    WhyChooseheading: "Simple Booking Process",
    WhyChoosedescription: "Receive quick support for taxi availability, fare information, and vehicle selection for your Belgaum to Jamkhandi journey."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Jamkhandi Cab Service?",
    answer: "Yes, we provide Belgaum to Jamkhandi cab services with comfortable cars and professional drivers for a smooth journey."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Jamkhandi?",
    answer: "Yes, one-way cab services are available for passengers who need direct travel between Belgaum and Jamkhandi."
  },
  {
    question: "What types of cars are available for this route?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV vehicles based on your requirements."
  },
  {
    question: "Is Belgaum to Jamkhandi taxi suitable for family travel?",
    answer: "Yes, comfortable and spacious vehicles are available for families and groups travelling between Belgaum and Jamkhandi."
  },
  {
    question: "Can I book a return cab from Jamkhandi to Belgaum?",
    answer: "Yes, return trip taxi options are available with flexible schedules according to your travel plans."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop services are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I hire a private cab from Belgaum to Jamkhandi?",
    answer: "Yes, private taxi services are available with dedicated vehicles and drivers for a comfortable travel experience."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Additional charges such as toll, parking, and other applicable fees depend on the selected travel package and are explained during booking."
  },
  {
    question: "Is Belgaum to Jamkhandi taxi service available anytime?",
    answer: "Yes, cab booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Jamkhandi Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vishal Kulkarni",
    feedback: "The Belgaum to Jamkhandi cab service was convenient and comfortable. The driver was punctual, and the journey was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shalini Patil",
    feedback: "A pleasant travel experience with a clean vehicle and helpful driver. The service made our trip simple and stress-free.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Jamkhandi Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-jamkhandi-cab.webp",
  "description":
    "Book Belgaum to Jamkhandi Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Jamkhandi with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-jamkhandi-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Belgaum to Jamkhandi Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Jamkhandi Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Jamkhandi with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable local and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Jamkhandi Cab, Belgaum to Jamkhandi Taxi, Belgaum to Jamkhandi Cab Service, Belgaum to Jamkhandi Taxi Service, Belgaum to Jamkhandi One Way Cab, Belgaum to Jamkhandi One Way Taxi, Belgaum to Jamkhandi Cab Booking, Belgaum to Jamkhandi Taxi Booking, Belgaum to Jamkhandi Car Rental, Belgaum to Jamkhandi Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtojamkhandicab;